import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import idb from './modules/iDb'
import siteConfig from './modules/siteConfig'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    idb,
    siteConfig
  }
})
